module.exports = __webpack_public_path__ + "img/bi_sub1.a91eba94.jpg";